import {matchMediaXlUp} from "../mediaQuery";

export const mainMenuTab = () => ({
    active: 'alpine',

    toggleCategory() {
        console.log('toogle');
        this.active = this.active === 'alpine' ? 'outdoor' : 'alpine';

        if (!matchMediaXlUp.matches) return;

        const target = document.querySelector('.mega-dropdown.show .mega-dropdown__mask--v2')
        const container = document.querySelector('.mega-dropdown.show .mega-dropdown__mask--v2 > .container')

        setTimeout(() => {
            target.setAttribute('data-height', container.getBoundingClientRect().height)
            target.style.height = container.getBoundingClientRect().height + 'px'
        }, 250)
    }
})
